module.exports = __webpack_public_path__ + "static/img/R.c62c4ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/devices/R.png
// module id = yA2M
// module chunks = 0